import React, { Component } from 'react';
import styled from 'styled-components';
import { Transition } from 'react-transition-group';
import { images } from 'config';
import { transitionStyles } from './dropdownStyles';
import { strings } from 'config';

class DownloadDropdown extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false
    };

    this.handleDropdownMenu = this.handleDropdownMenu.bind(this);
  }

  handleDropdownMenu(dropdownState) {
    this.setState({
      isOpen: dropdownState
    });
  }

  getFileName = link => {
    const linkArr = link.split('/');
    const fileName = linkArr[linkArr.length - 1].split('_');
    return fileName[fileName.length - 1];
  };

  render() {
    const { documents, downloadAll } = this.props;
    return (
      <Dropdown
        onMouseEnter={() => this.handleDropdownMenu(true)}
        onMouseLeave={() => this.handleDropdownMenu(false)}
      >
        <DropdownButton isOpen={this.state.isOpen}>
          <Title className="title" isOpen={this.state.isOpen}>
            {strings.detail.downloadDocuments}
          </Title>
          <DropdownIcon isOpen={this.state.isOpen} />
        </DropdownButton>

        <Transition in={this.state.isOpen} timeout={100} mountOnEnter={true}>
          {state => (
            <DropdownMenu
              style={{
                ...transitionStyles[state]
              }}
              icon={images.icons.download}
            >
              <ul className="dropdown-list">
              {documents.length > 1 &&
                <li className="dropdown-list-item">
                <a href={downloadAll}>
                  <span>{strings.detail.downloadAll}</span>
                </a>
              </li>
              }
               
                {documents &&
                  documents.map((val, index) => (
                    <li key={index} className="dropdown-list-item">
                     {/* <img src={images.icons.download} alt="Download Icon"/> */}
                      <a href={val}>{this.getFileName(val)}</a>
                    </li>
                  ))}
              </ul>
            </DropdownMenu>
          )}
        </Transition>
      </Dropdown>
    );
  }
}

export default DownloadDropdown;

const DropdownButton = styled.span`
  position: relative;
  display: inline-block;
  border-radius: 2px;
  font-size: 12px;
  cursor: pointer;
  padding: 18px 48px;
  border-radius: 30px;

  background-color: ${props =>
    props.isOpen ? '#01887e' : props.theme.teals.tilicho};
`;

const Title = styled.span`
  color: #fff;
  font-size: 16px;
  cursor: pointer;
  margin-right: 16px;
  white-space: nowrap;
`;

const DropdownIcon = styled.span`
  border-color: ${props =>
    props.isOpen ? `transparent transparent #fff` : `#fff transparent transparent;`}
    border-width: ${props => (props.isOpen ? '0 4px 4px' : '4px 4px 0')};
  border-style: solid;
  display: inline-block;
  vertical-align: middle;
  position: absolute;
  right: 24px;
  top: 50%;
  transform: translateY(-50%);
`;

const Dropdown = styled.span`
  position: relative;
`;

const DropdownMenu = styled.ul`
  padding-top: 24px;
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  min-width: 184px;
  z-index: 1000;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-4px);
  transition: all 300ms ease-in-out;

  .dropdown-list {
    background-color: ${props => props.theme.primary.raju};
    border-radius: 4px;
    box-shadow: 0 8px 40px -8px rgba(0, 0, 0, 0.15);
    padding: 0 20px;

    .dropdown-list-item {
      display: block;
      padding: 14px 36px;
      font-size: 14px;
      transition: all 0.2s ease-in;
      line-height: 1.4;
      cursor: pointer;
      background: url('${props => props.icon}') no-repeat 10px center;
      &:not(:last-child) {
        border-bottom: 1px solid #e4eaeb;
      }
      &:hover {
        color: ${props => props.theme.primary.ujyaalo};
        cursor: pointer;
      }

      img {
        display: inline-block;
        vertical-align: middle;
        margin-right: 8px;
      }

      > a {
        color: #4a4a4a;
        &.active {
          color: ${props => props.theme.primary.ujyaalo};
        }

        &:hover {
          color: ${props => props.theme.primary.ujyaalo};
          cursor: pointer;
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/layouts/dropdowns/downloadDropdown.js